import styled, { css } from 'styled-components';
import { ModalContent } from '../../ui/Select/styled';
import { FlexCenterAligned } from '../../../styled/common';
import { Header } from '../../ui/PageHeader/styled';
import { Breakpoints } from '../../../styled/constants';
import { animation } from '../../../styled/placeholders.styled';
import { getSafeAreaValue } from '../../../styled/theme/helpers/getSafeAreaValue';

export const modalStyles = css`
  ${ModalContent} {
    padding: 0 15px ${({ theme }) => getSafeAreaValue(theme, 'bottom', 0)};
  }

  ${Header} {
    border-bottom: none;
  }
`;

export const SelectedValueContainer = styled(FlexCenterAligned)`
  > svg {
    stroke-width: 0.6;
  }

  font-size: 16px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    gap: 3px;
    justify-content: flex-start;
  }

  @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    &,
    span {
      font-size: 0;
    }
  }
`;

export const SortingContainer = styled.div`
  margin: 0 -10px;

  label {
    padding: 0 10px;
    height: 54px;

    &::after {
      display: none;
    }

    > span {
      font-size: 15px;
    }
  }
`;

export const SortingPlaceholder = styled(SelectedValueContainer)`
  ${animation};
  height: 50px;
  width: 50px;
  border-radius: 14px;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    width: 217px;
  }
`;
